import * as React from 'react';
import { css } from 'aphrodite';
import { Field } from 'redux-form';

import PrimaryButton from '../Buttons/PrimaryButton';
import ErrorMessage from '../Notifications/ErrorMessage/ErrorMessage';
import PaneFormHeader, { PaneFormHeaderProps } from '../PaneLayout/PaneFormHeader';
import { paneFormStyles } from '../PaneLayout/paneStyles';

export interface FormSection {
  header: PaneFormHeaderProps;
  inputs: FormInput[];
}

interface FormWithSectionsProps {
  error?: string;
  formSections: FormSection[];
  termsInputs?: FormInput[];
  onSubmit: (event: React.FormEvent<any>) => void;
  submitting?: boolean;
}

export class FormWithSections extends React.Component<FormWithSectionsProps> {
  render() {
    const { error, formSections, onSubmit, termsInputs = [], submitting } = this.props;

    return (
      <div className="FormWithSections">
        {error && (
          <div className={css(paneFormStyles.errorWrapper)}>
            <ErrorMessage errorText={error} data-it="FormWithSections-errorMessage" />
          </div>
        )}
        <form className={css(paneFormStyles.wrapper)} noValidate onSubmit={onSubmit}>
          {/* We wrap all the form sections in a div in order to select on the last one with :last-child and
              stop it from adding extra padding */}
          <div>
            {formSections.map(definition => (
              <div className={css(paneFormStyles.sectionWrapper)} key={definition.header.text}>
                <PaneFormHeader {...definition.header} />
                <div className={css(paneFormStyles.inputsWrapper)}>
                  {definition.inputs.map(input => (
                    <div className={css(paneFormStyles.fieldWrapper)} key={input.name}>
                      <Field {...input} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className={css(paneFormStyles.buttonPadding)}>
            {termsInputs.map(input => (
              <div
                className={css(paneFormStyles.fieldWrapper)}
                key={input.name}
                data-it={`FormWithSections-${input.name}`}
              >
                <Field {...input} />
              </div>
            ))}
            <div className={css(paneFormStyles.buttonDisplay)}>
              <PrimaryButton
                isWide
                text="Continue"
                fontFamily="Roboto"
                data-it="FormWithSections-continue"
                disabled={submitting}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default FormWithSections;
